import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
const TakeAway = () => {
  const [orderList, setOrderList] = useState([]);
    const navigate = useNavigate();
  useEffect(() => {
    const fetchItems = () => {
      fetch("http://103.235.105.54/admin/api/takeAwayOrderList", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          branch_id: sessionStorage.getItem("branch_id"),
          company_id: sessionStorage.getItem("company_id"),
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Fetched data:", data);
          if (data.status === true) {
            setOrderList(data.data);
          }
        })
        .catch((err) => console.error("Fetch error:", err));
    };

    fetchItems();
    const interval = setInterval(fetchItems, 50000);
    return () => clearInterval(interval);
  }, []);

  // helper: sum of all tax fields
  const calculateTax = (order) => {
    const cgst = parseFloat(order.cgst) || 0;
    const sgst = parseFloat(order.sgst) || 0;
    const igst = parseFloat(order.igst) || 0;
    const vat = parseFloat(order.vat) || 0;
    const tax = parseFloat(order.tax) || 0;
    return (cgst + sgst + igst + vat + tax).toFixed(2);
  };
    const handlePayNow = async(orderId) => {
 try {
      if (!orderId) return;

      const res = await fetch(
        `http://103.235.105.54/admin/api/takeaway-order/${orderId}`
      );
      const data = await res.json();
      console.log("API Response:", data);

      if (data.status && data.data.length > 0) {
        const order = data.data[0];
        

        // Save full response to sessionStorage
        sessionStorage.setItem("orderResponse", JSON.stringify(data));
        navigate(`/order-update/${order.id}`);
      }
    } catch (err) {
      console.error("Error fetching order:", err);
    }

  
    };
    const orderTypeMap = {
  "dine-in": 1,
  "takeaway": 2,
  "delivery": 3,
};
  // helper: format date dd-mm-yyyy H:i:s
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <main className="main-wrapper">
      <div className="main-content">
        <div className="row">
          <div className="col-12">
            <h2>Take Away Orders</h2>
            {orderList.length === 0 ? (
              <p>No orders found.</p>
            ) : (
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>Price</th>
                    <th>Tax</th>
                    <th>Total</th>
                    {/* <th>Payment Mode</th> */}
                    <th>Status</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {orderList.map((order) => (
                    <tr key={order.id}>
                      <td>{order.id}</td>
                      <td>{order.customer_name || "Guest"}</td>
                      <td>₹{order.price}</td>
                      <td>₹{calculateTax(order)}</td>
                      <td>₹{order.total_price}</td>
                      {/* <td>
                        {order.payment_mode === 1
                          ? "Cash"
                          : order.payment_mode === 2
                          ? "Card"
                          : "Other"}
                      </td> */}
                      <td>
                        {order.order_status === 1 ? "Pending" : "Completed"}
                      </td>
                      <td>{formatDate(order.created_at)}</td>
                      <td>
                         <button
    className="pay-btn mt-3"
    onClick={() => handlePayNow(order.id)}
  >
    More/Pay
  </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default TakeAway;
